import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { ThumbnailBig, FooterSection } from '@components'
import './PiagamCorporateGovernance.scss'
import { CorporateGovernanceAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { TitleComponent } from '../../../common/components/TitleComponent'
import MyMenu from '../MyMenu'
import { Accordion } from '../../../common/components'
import { IconDownload } from '../../../assets/icons'

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const Subtitle = styled.h4`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 150%;
  color: #5e514d;
`

const P = styled.p`
  color: #5e514d;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 150%;
`

const CorporateGovernanceContainer = styled.div`
  margin-top: 56px;
  padding: 24px 119px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px;
  }
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const PiagamCorporateGovernance = function () {
  const { t } = useTranslation()
  const [data, setdata] = useState([])
  const [isLoading, setisLoading] = useState(false)

  useEffect(() => {
    loadData()
  }, [])

  const loadData = async function () {
    setisLoading(true)
    const { data } = await CorporateGovernanceAPI('piagam')
    setdata(data.data)
    setisLoading(false)
  }

  return (
    <div>
      <TitleComponent title={isLoading ? '' : data.judulBannerPiagam} />
      <Container>
        <Desktop>
          <ThumbnailBig
            title={isLoading ? '' : data.judulBannerPiagam}
            desc={isLoading ? '' : data.deskripsiBannerPiagam}
            img={isLoading ? '' : data.imageBannerDesktopPiagam}
          />
        </Desktop>
        <Mobile>
          <ThumbnailBig
            title={isLoading ? '' : data.judulBannerPiagam}
            desc={isLoading ? '' : data.deskripsiBannerPiagam}
            img={isLoading ? '' : data.imageBannerMobilePiagam}
          />
        </Mobile>
      </Container>

      <CorporateGovernanceContainer className="container-fluid">
        <div className="m-0 row">
          <div className="p-0 col-lg-9 col-12">
            <div className="p-0 col-12">
              {typeof data.blockDataPiagamKomite != 'undefined' &&
                data.blockDataPiagamKomite.length > 0 && (
                  <div className="mb-5">
                    <h2 className="mt-5 mb-4 section-title">
                      {data.judulAccordionPiagamKomite}
                    </h2>

                    <div className="row list-piagam">
                      {data.blockDataPiagamKomite.map((item, index) => {
                        return (
                          <Accordion key={index} title={item.judulPiagamKomite}>
                            {/* {`<img
                              style="width: 100% !important; margin: 0 !important;"
                              src=${item.linkFile}
                              alt=${item.judulPiagamKomite}
                            />`} */}
                            {`
                              <a href=${item.linkFile} target="blank">
                                ${item.judulPiagamKomite}
                                <img src=${IconDownload} alt="icon-download" />
                              </a>
                            `}
                          </Accordion>
                        )
                      })}
                    </div>
                  </div>
                )}
            </div>
            <div className="p-0 col-12">
              {typeof data.blockDataPiagamAudit != 'undefined' &&
                data.blockDataPiagamAudit.length > 0 && (
                  <div className="mb-5">
                    <h2 className="mt-5 mb-4 section-title">
                      {data.judulAccordionPiagamAudit}
                    </h2>
                    <Subtitle>{t('pengantar')}</Subtitle>
                    <P>{data.descAccordionPiagamAudit}</P>

                    <div className="row mt-4">
                      {data.blockDataPiagamAudit.map((item, index) => {
                        return (
                          <Accordion key={index} title={item.judulPiagamAudit}>
                            {item.deskripsiPiagamAudit}
                          </Accordion>
                        )
                      })}
                    </div>
                  </div>
                )}
            </div>
          </div>
          <div className="d-none d-lg-block col">
            <MyMenu active={1} />
          </div>
        </div>
      </CorporateGovernanceContainer>
      <FooterSection currentPage={t('piagam')} />
    </div>
  )
}

export default PiagamCorporateGovernance
